import * as svg from "../../../assets/eye-off-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const EyeOffIcon = iconBuilder(svg, "EyeOffIcon", "0 0 12 12");
